import React from 'react'
import cn from 'classnames'

import { commonTheme } from '../../themes'

import * as Styles from './styles'
import './styles.css'

interface ErrorViewProps {
   imageUrl?: string
   title?: string
   imageClassName?: string
   description?: string
   descriptionClassName?: string
   containerClassName?: string
   renderActionItem?: () => JSX.Element
}

const ErrorView = (props: ErrorViewProps): React.ReactElement => {
   const {
      imageUrl,
      title,
      description,
      containerClassName,
      imageClassName,
      descriptionClassName,
      renderActionItem
   } = props

   const colorTheme = commonTheme.errorView

   return (
      <div
         className={cn(
            Styles.containerStyles,
            containerClassName,
            'error-view-container',
            colorTheme.bgColor
         )}
      >
         <img
            className={cn(imageClassName, Styles.imgClass)}
            src={imageUrl}
            alt={title || description}
         />
         <h3 className={cn(Styles.titleStyles, colorTheme.titleColor)}>
            {title}
         </h3>
         <p
            className={cn(
               Styles.descriptionStyles,
               colorTheme.descriptionColor,
               descriptionClassName
            )}
         >
            {description}
         </p>
         {renderActionItem ? renderActionItem() : null}
      </div>
   )
}

export default ErrorView
